import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  isSelected?: boolean;
}
export const Root = styled.div`
  font-family: Roboto;
  margin-top:6px;
  padding: 0px 4px;
`;


export const OptionsList = styled.div`
  width: 285px;
  height: 60px;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
  z-index: 51;
  margin-top: 16px;
  margin-left: -285px;
  padding: 14px 19.5px;
  flex-direction:column; 
`;
export const optionContainer = styled.div`
  display:flex;
  flex-direction:row;  
  align-items: center;
  margin-top:10px;
  width:100%;
`;


export const Label = styled.div`
  display:flex;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin:6px 10px 10px 10px;
  width:100px;
`;

export const SliderContainer = styled.div`
  display:flex;  
  width:100%;
  margin:10px;
`;

export const InputSlider = styled.input
`
  width: 40px;
  height: 18px;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  background-color: var(--white);
  text-align: center;
  margin:10px;
  outline: none;
`;


export const ButtonContainer = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${C.WHITE};
  display:flex;
  width: 36px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: ${(props: IRootProps) => props.isSelected ? "#122442" : ""};
  &:hover {
      background-color: ${C.GRAY}
    }
`;